import {
    clearStoredAccessToken,
    getStoredAccessToken,
    getTokenSnapshot,
    setStoredAccessToken,
} from '../utils/authStorage';

function notifyAuthChange(detail = {}) {
    window.dispatchEvent(new CustomEvent('auth-change', { detail }));
}

function clearTokenInternal(reason = 'cleared') {
    clearStoredAccessToken();
    notifyAuthChange({ reason });
}

export const getAuthState = () => {
    const snapshot = getTokenSnapshot();

    if (snapshot.status === 'invalid' || snapshot.status === 'expired') {
        clearStoredAccessToken();
        return {
            token: '',
            payload: null,
            status: snapshot.status,
            isAuthenticated: false,
        };
    }

    return snapshot;
};

export const hydrateAuthState = () => {
    const snapshot = getTokenSnapshot();
    if (snapshot.status === 'invalid' || snapshot.status === 'expired') {
        clearTokenInternal(snapshot.status);
        return {
            token: '',
            payload: null,
            status: snapshot.status,
            isAuthenticated: false,
        };
    }

    notifyAuthChange({ reason: 'hydrated', status: snapshot.status });
    return snapshot;
};

export const getToken = () => {
    const authState = getAuthState();
    return authState.token || '';
};

export const getTokenPayload = () => {
    const authState = getAuthState();
    return authState.payload || null;
};

export const getCurrentUsername = () => {
    return getTokenPayload()?.sub || '';
};

export const setToken = (token) => {
    if (!token) return;
    setStoredAccessToken(token);
    notifyAuthChange({ reason: 'login' });
};

export const clearToken = () => {
    clearTokenInternal('logout');
};

export const isLoggedIn = () => {
    const authState = getAuthState();
    return authState.isAuthenticated;
};

export const hasStoredToken = () => {
    return Boolean(getStoredAccessToken());
};
